import type { IAction } from '../../action/IAction'
import { LinkWorkOrderTaskArgs } from './LinkWorkOrderTaskArgs'
import type { WorkOrder } from '../WorkOrder'
import { InputType } from 'type-graphql'

@InputType()
export class LinkNewWorkOrderTaskArgs extends LinkWorkOrderTaskArgs {}

export interface ILinkNewWorkOrderTask extends IAction<WorkOrder, LinkNewWorkOrderTaskArgs> {}
